import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/popover/style";
import _Popover from "antd/es/popover";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["mode", "popoverProps"];
import { SketchPicker } from '@chenshuai2144/sketch-color';
import React, { useContext } from 'react';
import useMergedState from "rc-util/es/hooks/useMergedState";
export var DEFAULT_COLORS = ['#FF9D4E', '#5BD8A6', '#5B8FF9', '#F7664E', '#FF86B7', '#2B9E9D', '#9270CA', '#6DC8EC', '#667796', '#F6BD16' // 9 - 黄色
];

var ColorPicker = function ColorPicker(_ref) {
  var mode = _ref.mode,
      popoverProps = _ref.popoverProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-field-color-picker');

  var _useMergedState = useMergedState('#1890ff', {
    value: rest.value,
    onChange: rest.onChange
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      color = _useMergedState2[0],
      setColor = _useMergedState2[1];

  var readDom = /*#__PURE__*/React.createElement("div", {
    className: prefixCls,
    style: {
      padding: 5,
      width: 48,
      border: '1px solid #ddd',
      borderRadius: '2px',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: color,
      width: 36,
      height: 14,
      borderRadius: '2px'
    }
  }));

  if (mode === 'read') {
    return readDom;
  }

  return /*#__PURE__*/React.createElement(_Popover, _extends({
    trigger: "click",
    placement: "right"
  }, popoverProps, {
    content: /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '-12px -16px'
      }
    }, /*#__PURE__*/React.createElement(SketchPicker, _extends({}, rest, {
      presetColors: rest.colors || rest.presetColors || DEFAULT_COLORS,
      color: color,
      onChange: function onChange(_ref2) {
        var hex = _ref2.hex,
            _ref2$rgb = _ref2.rgb,
            r = _ref2$rgb.r,
            g = _ref2$rgb.g,
            b = _ref2$rgb.b,
            a = _ref2$rgb.a;

        if (a && a < 1) {
          setColor("rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")"));
        }

        setColor(hex);
      }
    })))
  }), readDom);
};
/**
 * 颜色组件
 *
 * @param FieldColorPicker {
 *     text: number;
 *     moneySymbol?: string; }
 */


var FieldColorPicker = function FieldColorPicker(_ref3) {
  var text = _ref3.text,
      type = _ref3.mode,
      render = _ref3.render,
      renderFormItem = _ref3.renderFormItem,
      fieldProps = _ref3.fieldProps;

  if (type === 'read') {
    var dom = /*#__PURE__*/React.createElement(ColorPicker, {
      value: text,
      mode: "read"
    });

    if (render) {
      return render(text, _objectSpread({
        mode: type
      }, fieldProps), dom);
    }

    return dom;
  }

  if (type === 'edit' || type === 'update') {
    var _dom = /*#__PURE__*/React.createElement(ColorPicker, fieldProps);

    if (renderFormItem) {
      return renderFormItem(text, _objectSpread({
        mode: type
      }, fieldProps), _dom);
    }

    return _dom;
  }

  return null;
};

export default FieldColorPicker;